var jade = require("/web/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (me, view) {
buf.push("<div class=\"modal-body\"><div class=\"modal-body-content\"><h4 data-i18n=\"signup.account_created\" class=\"m-y-1\"></h4><div class=\"confirm_container text-center m-y-1\">");
if ( view.signupState.get('path') === 'student')
{
buf.push("<p data-i18n=\"signup.confirm_student_blurb\"></p>");
}
else
{
buf.push("<p data-i18n=\"signup.confirm_individual_blurb\"></p>");
}
buf.push("</div><div class=\"signup-info-box-wrapper\"><div data-i18n=\"signup.write_this_down\" class=\"text-burgundy\"></div><div class=\"signup-info-box text-center\">");
if ( me.get('name'))
{
buf.push("<h4><b><span data-i18n=\"general.username\"></span>: " + (jade.escape((jade_interp = me.get('name')) == null ? '' : jade_interp)) + "</b></h4>");
}
if ( me.get('email'))
{
buf.push("<h5><b>");
var ssoUsed = view.signupState.get('ssoUsed');
if ( ssoUsed === 'facebook')
{
buf.push("<img src=\"/images/pages/modal/auth/facebook_small.png\" class=\"m-r-1\">" + (jade.escape(null == (jade_interp = me.get('email')) ? "" : jade_interp)));
}
else if ( ssoUsed === 'gplus')
{
buf.push("<img src=\"/images/pages/modal/auth/gplus_small.png\" class=\"m-r-1\">" + (jade.escape(null == (jade_interp = me.get('email')) ? "" : jade_interp)));
}
else
{
buf.push("<span data-i18n=\"general.email\"></span>: " + (jade.escape((jade_interp = me.get('email')) == null ? '' : jade_interp)) + "");
}
buf.push("</b></h5>");
}
buf.push("</div></div>");
if ( view.signupState.get('wantInSchool'))
{
buf.push("<div id=\"nces-search-input\"></div>");
}
buf.push("<button id=\"start-btn\" data-i18n=\"signup.start_playing\" class=\"btn btn-navy btn-lg m-t-3\"></button></div></div>");}.call(this,"me" in locals_for_with?locals_for_with.me:typeof me!=="undefined"?me:undefined,"view" in locals_for_with?locals_for_with.view:typeof view!=="undefined"?view:undefined));;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/templates/core/create-account-modal/confirmation-view.jade
// module id = 848
// module chunks = 0 9 12 13 15 16 79 80 81 82 83 84 85 86 87 88 89 90 91